import { balanceEndpoints } from "./balance.api.ts"

export * from "./balance.types"

export const {
  useGetBalanceQuery,
  endpoints: { getBalance }
} = balanceEndpoints
